export const SAVE_POLYLINE = "polyline/SAVE_POLYLINE";
export const SAVE_POLYLINE_SUCCESS = "polyline/SAVE_POLYLINE_SUCCESS";
export const SAVE_POLYLINE_ERROR = "polyline/SAVE_POLYLINE_ERROR";

export const UPDATE_POLYLINE = "polyline/UPDATE_POLYLINE";
export const UPDATE_POLYLINE_SUCCESS = "polyline/UPDATE_POLYLINE_SUCCESS";
export const UPDATE_POLYLINE_ERROR = "polyline/UPDATE_POLYLINE_ERROR";
